export const isImageMediaType = (mediaType?: string): boolean => {
  if (!mediaType) {
    return false;
  }

  return mediaType.startsWith('image/');
};
